<!-- 动态详情 -->
<template>
    <div class="dynamicStateDetails">
        <div class="userMsgBox" v-if="init">
            <div class="userMsg">
                <div class="user">
                    <img :src="diaryBaseInfo.customerlogo" class="customerlogo" alt="">
                    <div class="customerDutyCompanyName">
                        <div class="customername">{{diaryBaseInfo.customername}}</div>
                        <div class="dutyCompanyName">
                            <span class="nameItem">{{diaryBaseInfo.dutyname}}</span>
                            <span class="vertical">|</span>
                            <span class="nameItem">{{diaryBaseInfo.companyname}}</span>
                        </div>
                    </div>
                </div>
                <div class="msgContent" v-html="formatContent(diaryBaseInfo.content)"></div>
                <!-- 图片 -->
                <div class="imagelistBox" v-if="diaryBaseInfo.imagelist && diaryBaseInfo.imagelist.length">
                    <div class="imgWrap" v-if="diaryBaseInfo.imagelist.length === 1">
                        <img :src="item.atturl" class="onwImg" alt="" v-for="(item, index) in diaryBaseInfo.imagelist" :key="index" />
                    </div>
                    <div class="imgWrap" v-if="diaryBaseInfo.imagelist.length > 1">
                        <img :src="item.atturl" :style="{height: imgHeight}" class="moreImg" alt="" v-for="(item, index) in diaryBaseInfo.imagelist" :key="index">
                    </div>
                </div>
                <!-- 链接 -->
                <div class="linklist" v-if="diaryBaseInfo.linklist && diaryBaseInfo.linklist.length">
                    <div class="item" @click="handleClickLinkItem(item)" v-for="(item, index) in diaryBaseInfo.linklist" :key="index">
                        <img :src="item.linklogourl" class="linklogourl" alt="">
                        <div class="linkname text-ellipses">{{item.linkname}}</div>
                    </div>
                </div>
                <div class="hanldeBox">
                    <div class="item" @click="handleOpenAppTips">
                        <img :src="require('@/common/images/mobile/comment_icon.png')" class="icon" alt="">
                        <div class="value">{{diaryBaseInfo.commentcount ? diaryBaseInfo.commentcount : '评论'}}</div>
                    </div>
                    <div class="item" @click="handleOpenAppTips">
                        <img :src="require('@/common/images/mobile/like_icon.png')" class="icon" alt="">
                        <div class="value">{{diaryBaseInfo.praisecount ? diaryBaseInfo.praisecount : '点赞'}}</div>
                    </div>
                    <div class="item" @click="handleOpenAppTips">
                        <img :src="require('@/common/images/mobile/collect_icon.png')" class="icon" alt="">
                        <div class="value">{{diaryBaseInfo.favoritecount ? diaryBaseInfo.favoritecount : '收藏'}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="commentBox" v-if="init">
            <div class="title">评论（{{commentTotal}}）</div>
            <van-list v-model="loading" :finished="finished" :finished-text="commentList.length ? '没有更多了' : ''" @load="onLoad">
                <div class="noData" v-if="!commentList.length">
                    <img :src="require('@/common/images/mobile/img-noData.png')" class="noDataImg" alt="">
                    <p class="tips">暂无评论</p>
                </div>
                <div class="listBox" v-else>
                    <div class="item" v-for="(item, index) in commentList" :key="index">
                        <div class="commentUserMsg">
                            <img :src="item.customerlogo" class="customerlogo" alt="">
                            <div class="userMsg">
                                <div class="nameDate">
                                    <div class="name">{{item.customername}}</div>
                                    <div class="date">{{item.datetime}}</div>
                                </div>
                                <div class="dutyCompanyName">
                                    <span class="nameItem">{{item.dutyname}}</span>
                                    <span class="vertical">|</span>
                                    <span class="nameItem2">{{item.companyname}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="commentContent">{{item.content}}</div>
                        <div class="handleBox">
                            <div class="handleItem">
                                <img :src="require('@/common/images/mobile/like_icon.png')" class="icon" alt="">
                                <div class="value">{{item.praisecount ? item.praisecount : '点赞'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
        <div class="bottomBtnBox">
            <a class="bottomBtn" @click="handleClickOpenApp" id="openAppATags" v-if="mobilePhoneType === 'iOS' || mobilePhoneType === 'wechat-iOS'" :href="'https://www.capwhale.com/ulink/iosdmapp/index/dynamicDetails/dynamicDetails?code=' + params.code">打开App进行更多操作</a>
            <a class="bottomBtn" @click="handleClickOpenApp" id="openAppATags" v-if="mobilePhoneType === 'android' || mobilePhoneType === 'wechat-android'" :href="'dmapp://index/dynamicDetails/dynamicDetails?code=' + params.code">打开App进行更多操作</a>
            <div class="wechatOpenApp" v-if="_isWixin() && mobilePhoneType === 'android'">
                <wx-open-launch-app id="launch-btn" appid="wx04d8952d30352373" @error="handlewxOpenApperror"
                    :extinfo="'dmapp://index/dynamicDetails/dynamicDetails?code=' + params.code"
                    style="position:absolute;top:0;right:0;width: 100%;height: 0.9rem;zIndex: 1000;display: flex;alignItems: center;justifyConent: center">
                    <script type="text/wxtag-template">
                        <style>.btn { padding: 500px;color: transparent;text-align: center;background: transparent;border: none;display: block;}</style>
                        <button class="btn">立即打开</button>
                    </script>
                </wx-open-launch-app>
            </div>
        </div>
    </div>
</template>

<script>
import { getDiaryBaseInfo, getDiaryCommentList } from 'api/api.js'
import { mapActions } from 'vuex'
import { examineMobilePhoneType } from 'common/js/tools.js'
import {getWXSDKSetting} from 'common/js/wxSDKSetting'
export default {
    data() {
        return {
            params: {
                code: '',
                apptype: ''
            },
            commentParams: {
                page: 0,
                pagesize: 10
            },
            diaryBaseInfo: {},
            init: false,
            commentTotal: 0,
            commentList: [],
            loading: false,
            finished: false,
            imgHeight: '',
            mobilePhoneType: examineMobilePhoneType()
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if (this.$route.query.code && this.$route.query.apptype) {
            this.params.code = this.$route.query.code
            this.params.apptype = this.$route.query.apptype
            this.getDiaryBaseInfo()
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        document.title = '动态详情'
    },
    methods: {
        getDiaryBaseInfo() {
            this.setLoading(true)
            getDiaryBaseInfo({
                data: this.params,
                success: res => {
                    this.setLoading(false)
                    this.diaryBaseInfo = res.data
                    this.init = true
                    this.$nextTick(() => {
                        if (this.diaryBaseInfo.imagelist && this.diaryBaseInfo.imagelist.length > 1) {
                            this.imgHeight = document.querySelector('.moreImg').width + 'px'
                        }
                    })
                    if (this._isWixin()) {
                        let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?code=' + this.$route.query.code
                        getWXSDKSetting({
                            title: '动态详情',
                            desc: '',
                            link: link,
                            imgUrl: '',
                        })
                    }
                    // this.getDiaryCommentList()
                },
                error: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        formatContent(content) {
            let str = content.replace(/\n/g, '<br/>')
            let tags = str.match(/#[^#]*#/g);
            if (tags) {
                let arr = []
                tags.map(item => {
                    if (!arr.includes(item)) {
                        arr.push(item)
                        let reg = "/" + item + "/g";
                        let myregex = eval(reg);//转换为正则对象
                        str=str.replace(myregex,"<a style='color: #74CEFF' class='tags'>"+item+"</a>")
                    }
                })
            }
            return str
        },
        onLoad() {
            ++this.commentParams.page
            this.getDiaryCommentList()
        },
        getDiaryCommentList() {
            this.setLoading(true)
            this.loading = true
            getDiaryCommentList({
                data: Object.assign({}, {condition: this.params}, this.commentParams),
                success: res => {
                    this.loading = false
                    this.setLoading(false)
                    this.commentTotal = res.pageableData.rowCount
                    if (this.commentParams.page === 1) {
                        this.commentList = res.data
                    } else {
                        this.commentList = this.commentList.concat(res.data)
                    }
                    if (this.commentList.length >= this.commentTotal) {
                        this.finished = true
                    } else {
                        this.finished = false
                    }
                },
                error: res => {
                    this.loading = false
                    this.finished = true
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        handleClickLinkItem(item) {
            if (item.linktype === 1) { // 话题

            } else if (item.linktype === 99) { // 自定义链接
                location.href = item.linkurl
            }
        },
        handleOpenAppTips() {
            this.$dialog.alert({
                title: '提示',
                message: '打开App进行更多操作',
            }).then(() => {
                document.getElementById('openAppATags').click()
            })
        },
        _isWixin() {
            let ua = window.navigator.userAgent.toLowerCase()
            if (/micromessenger/.test(ua)) {
                return true
            } else {
                return false
            }
        },
        handlewxOpenApperror(e) {
            let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?code=' + this.$route.query.code + '&apptype=' + this.$route.query.apptype
            if (e.detail.errMsg === 'launch:fail') { // 未安装APP
                if (this.mobilePhoneType === 'iOS') {
                    window.location.href = 'https://apps.apple.com/cn/app/id6443889977'
                } else {
                    window.location.href = 'https://m.capwhale.com/mdmapp?topage=' + encodeURIComponent(link)
                }
            } else if (e.detail.errMsg === 'launch:fail_check fail') { // appid未绑定未关联到微信
                if (this.mobilePhoneType === 'iOS') {
                    window.location.href = 'https://apps.apple.com/cn/app/id6443889977'
                } else {
                    window.location.href = 'https://m.capwhale.com/mdmapp?topage=' + encodeURIComponent(link)
                }
            }
        },
        handleClickOpenApp() {
            let link = window.location.protocol + '//' + window.location.host + window.location.pathname + '?code=' + this.$route.query.code + '&apptype=' + this.$route.query.apptype
            setTimeout(() => {
                if (this.mobilePhoneType === 'iOS') {
                    window.location.href = 'https://apps.apple.com/cn/app/id6443889977'
                } else {
                    window.location.href = 'https://m.capwhale.com/mdmapp?topage=' + encodeURIComponent(link)
                }
            }, 2000)
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.dynamicStateDetails {
    padding-bottom: 1rem;
    height: 100vh;
    overflow: scroll;
    box-sizing: border-box;
    background: #FAFAFA;
    .userMsgBox {
        padding: 0.2rem 0.3rem;
        background: #fff;
        border-bottom: 0.01rem solid #EEEEEE;
        .userMsg {
            padding: 0.3rem 0.3rem 0.2rem;
            box-shadow: 0px 0.02rem 0.18rem 0px rgba(188,188,188,0.25);
            border-radius: 0.2rem;
            .user {
                display: flex;
                margin-bottom: 0.2rem;
                .customerlogo {
                    width: 0.98rem;
                    height: 0.98rem;
                    margin-right: 0.3rem;
                    border-radius: 0.1rem;
                }
                .customerDutyCompanyName {
                    height: 0.98rem;
                    flex: 1;
                    width: 0;
                    padding: 0.06rem 0;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .customername {
                        font-size: 0.28rem;
                        color: #333333;
                        line-height: 0.34rem;
                    }
                    .dutyCompanyName {
                        font-size: 0.24rem;
                        color: #999999;
                        line-height: 0.28rem;
                        .vertical {
                            margin: 0 0.2rem
                        }
                    }
                }
            }
            .msgContent {
                font-size: 0.26rem;
                color: #666666;
                line-height: 0.4rem;
            }
            .imagelistBox {
                margin-top: 0.2rem;
                .imgWrap {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    .onwImg {
                        max-height: 3.2rem;
                        max-width: 100%;
                        margin-right: 0;
                    }
                    .moreImg {
                        width: 31%;
                    }
                    img {
                        object-fit: cover;
                        margin-top: 0.2rem;
                        margin-right: 0.2rem;
                        &:nth-child(3n) {
                            margin-right: 0;
                        }
                    }
                }
            }
            .linklist {
                .item {
                    display: flex;
                    height: 0.84rem;
                    align-items: center;
                    margin-top: 0.2rem;
                    padding: 0.2rem 0.22rem;
                    background: #F6F6F6;
                    .linklogourl {
                        height: 0.84rem;
                        width: 1.48rem;
                        margin-right: 0.3rem;
                    }
                    .linkname {
                        flex: 1;
                        width: 0;
                        font-size: 0.26rem;
                        color: #999999;
                        line-height: 0.4rem;
                    }
                }
            }
            .hanldeBox {
                margin-top: 0.5rem;
                display: flex;
                justify-content: flex-end;
                .item {
                    display: flex;
                    align-items: center;
                    &:not(:last-of-type) {
                        margin-right: 0.3rem;
                    }
                    .icon {
                        width: 0.26rem;
                        height: 0.27rem;
                    }
                    .value {
                        margin-left: 0.1rem;
                        font-size: 0.24rem;
                        color: #999999;
                    }
                }
            }
        }
    }
    .commentBox {
        background: #fff;
        .title {
            padding: 0.2rem 0.3rem;
            border-top: 0.01rem solid #EEEEEE;
            border-bottom: 0.01rem solid #EEEEEE;
            font-size: 0.3rem;
            color: #333333;
        }
        .van-list {
            .noData {
                text-align: center;
                padding: 0.6rem 0;
                .noDataImg {
                    width: 1.69rem;
                    height: 1.63rem;
                    margin: auto;
                }
                .tips {
                    margin-top: 0.24rem;
                    color: #ccc;
                }
            }
            .listBox {
                .item {
                    padding: 0.3rem 0.6rem;
                    border-bottom: 0.01rem solid #EEEEEE;
                    .commentUserMsg {
                        display: flex;
                        align-items: center;
                        .customerlogo {
                            width: 0.98rem;
                            height: 0.98rem;
                            margin-right: 0.3rem;
                            border-radius: 0.1rem;
                        }
                        .userMsg {
                            padding: 0.06rem 0;
                            height: 0.98rem;
                            box-sizing: border-box;
                            flex: 1;
                            width: 0;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            .nameDate {
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                .name {
                                    font-size: 0.28rem;
                                    color: #333333;
                                    line-height: 0.34rem;
                                }
                                .date {
                                    font-size: 0.24rem;
                                    color: #999999;
                                    line-height: 0.28rem;
                                }
                            }
                            .dutyCompanyName {
                                font-size: 0.24rem;
                                color: #999999;
                                line-height: 0.28rem;
                                display: flex;
                                .nameItem2 {
                                    flex: 1;
                                    width: 0;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }
                                .vertical {
                                    margin: 0 0.2rem;
                                }
                            }
                        }
                    }
                    .commentContent {
                        margin-top: 0.2rem;
                        font-size: 0.26rem;
                        color: #666666;
                        line-height: 0.4rem;
                        padding-left: 1.28rem;
                    }
                    .handleBox {
                        margin-top: 0.28rem;
                        display: flex;
                        justify-content: flex-end;
                        .handleItem {
                            display: flex;
                            align-items: center;
                            .icon {
                                width: 0.26rem;
                                height: 0.27rem;
                            }
                            .value {
                                margin-left: 0.1rem;
                                font-size: 0.24rem;
                                color: #999999;
                            }
                        }
                    }
                }
            }
            .van-list__finished-text {
                background: #FAFAFA;
            }
        }
    }
    .bottomBtnBox {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0.88rem;
        .bottomBtn {
            height: 0.88rem;
            color: #fff;
            text-align: center;
            line-height: 0.88rem;
            background: #FF8D20;
            font-size: 0.28rem;
            display: block;
        }
        .wechatOpenApp {
            height: 0.88rem;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            overflow: hidden;
        }
    }
}
</style>